import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SorteosService {

  selectedSorteos: any = null;
  sorteosUrl = environment.API_URL+"/Sorteos";

  constructor(private http : HttpClient,
              private userService:    AuthService,
              private router : Router,
              @Inject(PLATFORM_ID) private platformId: Object
    ) { }


  getSorteos(): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + (isPlatformBrowser(this.platformId) ? localStorage.getItem('token') : '')
    })
    return this.http.get(this.sorteosUrl + '/GetSorteos', { headers: headers });
  }

  getByName(code: string) {
    const url = `${this.sorteosUrl}/${code}`;
    return this.http.get(url);
  }

  getHistorySorteos(){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' +  (isPlatformBrowser(this.platformId) ? localStorage.getItem('token') : '')
    })
    return this.http.get(this.sorteosUrl + '/HistorySorteos', { headers: headers });
  }

  convert(convertParams: any): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' +  (isPlatformBrowser(this.platformId) ? localStorage.getItem('token') : '')
    });
  
    const body = {
      itemCode: convertParams.itemCode,
      quantity: convertParams.quantity
    };
  
    return this.http.post(this.sorteosUrl + '/Cart', body, { headers: headers });
  }
  

}
